import {handleActions} from 'redux-actions';
import actions from './stream.actions';
import seedrandom from 'seedrandom';

const reducer = handleActions(
	{
		[actions.streamLoading]: state => ({
			...state,
			loading: true
		}),
		[actions.streamLoaded]: (state, {payload: {activities}}) => {
			const randNumGen = seedrandom(42); // must instantiate everytime

			// shuffle activities to introduce some randomness. Shuffle each half so newer
			// activities appear more towards the top of the stream
			const midPoint = Math.floor(activities.length / 2);
			const shuffle1 = activities.slice(0, midPoint).sort(() => randNumGen() - 0.5);
			const shuffle2 = activities.slice(midPoint, activities.length).sort(() => randNumGen() - 0.5);

			return {
				...state,
				loading: false,
				activities: [...state.activities, ...shuffle1, ...shuffle2],
				offset: state.offset + activities.length,
				endOfStream: activities.length === 0 // TODO: do this smarter!
			};
		},
		[actions.clearStream]: state => ({
			...state,
			loading: false,
			activities: [],
			offset: 0,
			endOfStream: false
		}),
		[actions.avatarsLoaded]: (state, {payload: {communityUuid, res}}) => {
			const newAvatars = state.communityAvatars;
			newAvatars[communityUuid] = res;

			return {
				...state,
				communityAvatars: {
					...newAvatars
				}
			};
		},
		[actions.communityListingModelOpened]: state => ({
			...state,
			communityListingModelStatus: true
		}),
		[actions.communityListingModelClosed]: state => ({
			...state,
			communityListingModelStatus: false
		}),
		[actions.streamPromotionAddModelOpened]: state => ({
			...state,
			streamPromotionAddModelStatus: true
		}),
		[actions.streamPromotionAddModelClosed]: state => ({
			...state,
			streamPromotionAddModelStatus: false
		})
	},
	{offset: 0, activities: [], loading: false, endOfStream: false, communityAvatars: {}}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/stream/stream.reducer.js